<template>
  <div>
    <v-form>
      <v-card flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">Bilet Rapor Ayarları</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn @click="Kaydet()" class="white--text" flat>Kaydet
              </v-btn>
            </v-toolbar>

          </v-flex>
          <v-container fluid>
            <v-layout row="" wrap="">

        <v-flex xs12 sm6 md2 pa-1>
          <v-card class="white--text">
            <v-card  flat="">
              <v-card-actions>
          <v-layout justify-space-between column>
                <v-text-field hide-details=""  v-model="BiletRaporParametre.ParametrePath.AmadeusPath" label="AMADEUS Path" ></v-text-field>
                <v-text-field hide-details="" label="GALILEO Path" v-model="BiletRaporParametre.ParametrePath.GalileoPath" color="-4"></v-text-field>
                <v-text-field hide-details="" label="TK İç Hat Path" v-model="BiletRaporParametre.ParametrePath.TKIchatPath" color="-4"></v-text-field>
                <v-text-field hide-details="" label="Atlasglobal" v-model="BiletRaporParametre.ParametrePath.AtlasPath" color="-4"></v-text-field>
                <v-text-field hide-details="" label="Onur Air Path" v-model="BiletRaporParametre.ParametrePath.OnurAirPath" color="-4"></v-text-field>
                <v-text-field hide-details="" label="Pegasus Path" v-model="BiletRaporParametre.ParametrePath.PegasusPath" color="-4"></v-text-field>
                <v-text-field hide-details="" label="Yedek 2 Path" v-model="BiletRaporParametre.ParametrePath.YedekPath" color="-4"></v-text-field>
                <v-text-field hide-details="" label="XML Path" v-model="BiletRaporParametre.ParametrePath.XmlPath" color="-4"></v-text-field>
                <v-text-field hide-details="" label="Wordspan Path" v-model="BiletRaporParametre.ParametrePath.WordSpanPath" color="-4"></v-text-field>
                <v-text-field hide-details="" label="SABRE Path" v-model="BiletRaporParametre.ParametrePath.SabrePath" color="-4"></v-text-field>
                <v-text-field hide-details="" label="İskonto Hesabı" v-model="BiletRaporParametre.ParametreCari.IskontoHesap" color="-4"></v-text-field>
                <v-text-field hide-details="" label="AMADEUS Hesabı" v-model="BiletRaporParametre.ParametreCari.AmadeusHesap" color="-4"></v-text-field>
                <v-text-field hide-details="" label="İç Hat Fat. Mail" v-model="BiletRaporParametre.ParametreFaturaDizayn.IcHatFaturaMail" color="-4"></v-text-field>
                <v-text-field hide-details="" label="Dış Hat Fat. Mail" v-model="BiletRaporParametre.ParametreFaturaDizayn.DisHatFaturaMail" color="-4"></v-text-field>
                <v-text-field hide-details="" label="İç Hat Fat. PDF" v-model="BiletRaporParametre.ParametreFaturaDizayn.IcHatFaturaPdf" color="-4"></v-text-field>
                <v-text-field hide-details="" label="Dış Hat Fat. PDF" v-model="BiletRaporParametre.ParametreFaturaDizayn.DisHatFaturaPdf" color="-4"></v-text-field>
                <v-text-field hide-details="" label="PDF Fath" v-model="BiletRaporParametre.ParametrePath.PdfPath" color="-4"></v-text-field>
                <v-text-field hide-details="" label="İç Hat Fatura" v-model="BiletRaporParametre.ParametreFaturaDizayn.IcHatFatura" color="-4"></v-text-field>
                <v-text-field hide-details="" label="İç Hat Döviz Fatura" v-model="BiletRaporParametre.ParametreFaturaDizayn.IcHatDovizFatura" color="-4"></v-text-field>
                <v-text-field hide-details="" label="Dış Hat Fatura" v-model="BiletRaporParametre.ParametreFaturaDizayn.DisHatFatura" color="-4"></v-text-field>
                <v-text-field hide-details="" label="Dış Hat Döviz Fatura" v-model="BiletRaporParametre.ParametreFaturaDizayn.DisHatDovizFatura" color="-4"></v-text-field>
                <v-text-field hide-details="" label="Cari Hareket Fatura" v-model="BiletRaporParametre.ParametreFaturaDizayn.CariHaraketFatura" color="-4"></v-text-field>


                <v-text-field hide-details="" label="Fatura Boyu" v-model="BiletRaporParametre.ParametreFaturaDizayn.FaturaBoy" color="-4"></v-text-field>
                <v-text-field hide-details="" label="Fatura Eni" v-model="BiletRaporParametre.ParametreFaturaDizayn.FaturaEn" color="-4"></v-text-field>
                <v-text-field hide-details="" label="Dekont Boyu" v-model="BiletRaporParametre.ParametreFaturaDizayn.DekontBoy" color="-4"></v-text-field>
                <v-text-field hide-details="" label="Dekont Eni" v-model="BiletRaporParametre.ParametreFaturaDizayn.DekontEn" color="-4"></v-text-field>
          </v-layout>

</v-card-actions>
            </v-card>
          </v-card>
        </v-flex>
<v-flex xs12 sm6 md5 pa-1>
          <v-card class="white--text">
            <v-card  flat="">
              <v-card-actions>
          <v-layout justify-space-between column>

                <v-switch label="THY (İç Hat) OPTAT Biletlerini Otomatik Aktar  " hide-details="" v-model="BiletRaporParametre.ParametreAktarim.OptatBiletOtomatikAktar"
                    ></v-switch>
                <v-switch label="THY (İç Hat) Elektronik Biletlerini Otomatik Aktar " hide-details="" v-model="BiletRaporParametre.ParametreAktarim.ElektronikBiletOtomatikAktar"
                    ></v-switch>
                <v-switch label="ATLASJET ve PEGASUS'ta Servis Tutarını Bilet Tutarına Ekle" v-model="BiletRaporParametre.ParametreAktarim.AtlasPegasusServisBileteEkle"
                  hide-details=""   ></v-switch>
                <v-switch label="THY (İç Hat) Biletlerini Otomatik Cariye Aktar" v-model="BiletRaporParametre.ParametreAktarim.TKIcHatOtomatikCariAktar"
                  hide-details=""   ></v-switch>
                <v-switch label="GALİLEO (Dış Hat) Biletlerin Otomatik Cariye Aktar" v-model="BiletRaporParametre.ParametreAktarim.GalileoDisOtomatikCariAktar"
                  hide-details=""   ></v-switch>
                <v-switch label="AMADEUS (Dış Hat) Biletlerin Otomatik Cariye Aktar" hide-details="" v-model="BiletRaporParametre.ParametreAktarim.AmadeusDisOtomatikCariAktar"
                    ></v-switch>
                <v-switch label="AMADEUS ve GALİLEO Aktarımında Carileri Eşleştirme" hide-details="" v-model="BiletRaporParametre.ParametreAktarim.AmadeusGalileoCariEslestirmeYok"
                    ></v-switch>
                <v-switch label="AMADEUS (Dış Hat) Aktarımında Servis Olmasada Cariye Aktar" hide-details="" v-model="BiletRaporParametre.ParametreAktarim.AmadeusServisOlmasadaCariAktar"
                    ></v-switch>

                <v-switch label="Faturası Dökülmüş Bir Biletin Carisi Değiştirilsin " hide-details=""
                    ></v-switch>
                <v-switch label="Fatura Onay Sorusu Sorma" hide-details=""
                    ></v-switch>
                <v-switch label="Faturada Ayrı Ayrı Seriyi Kullanmaya İzin Ver" v-model="BiletRaporParametre.ParametreFatura.FaturaAyriSeri"
                  hide-details=""   >
                </v-switch>
                <v-switch label="Dekontta Kredi Kart Numarası Gözüksün" v-model="BiletRaporParametre.ParametreFatura.DekontKrediKartNo"
                  hide-details=""   >
                </v-switch>


          </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

             <v-flex xs12 sm6 md5 pa-1>
          <v-card class="white--text">
            <v-card  flat="">
              <v-card-actions>
          <v-layout justify-space-between column>


                <v-switch label="Faturada Masraf Merkezi Seçimi Zorunlu " hide-details=""
                    ></v-switch>
                <v-switch label="Faturaları PDF Dosya Olarak Oluştur" hide-details="" v-model="BiletRaporParametre.ParametreFatura.FaturaPdf"
                    ></v-switch>
                <v-switch label="PEGASUS ve SUN EXPRESS EX Biletleri Aktarma " v-model="BiletRaporParametre.ParametreAktarim.PegasusSunExpressExBiletAktarma"
                  hide-details=""   ></v-switch>
                <v-switch label="Firma Kart Numarası Kontrolü Yapılsın" v-model="BiletRaporParametre.ParametreFatura.FirmaKartKontrol"
                  hide-details=""   ></v-switch>
                <v-switch label="Dekontta Şirket Bilgileri Gözüksün" v-model="BiletRaporParametre.ParametreFatura.DekontSirket"
                  hide-details=""   ></v-switch>
                <v-switch label="SABRE Kurumsal Aktarım" hide-details="" v-model="BiletRaporParametre.ParametreAktarim.SabreKurumsal"
                    ></v-switch>
                <v-switch label="ATLASJET CASH Biletleri Kredili Aktar" hide-details="" v-model="BiletRaporParametre.ParametreAktarim.AtlasCashBiletKrediliAktar"
                    ></v-switch>
                <v-switch label="Aktarımlarda Ceza Tutarını Ayır (THY,Peg.,SunEx.,Onur)" hide-details=""
                    ></v-switch>
<v-switch label="Dekontta Bilet Açıklamaları Gözüksün " hide-details="" v-model="BiletRaporParametre.ParametreFatura.DekontBiletAciklama"
                    ></v-switch>
                <v-switch label="Başlıkları Gözükmesin" hide-details="" v-model="BiletRaporParametre.ParametreFatura.DekontBaslikYok"
                    ></v-switch>
                <v-switch label="Dekontta Servis Tutarı Ayrı Gözüksün"
                  hide-details=""   >
                </v-switch>
                <v-switch label="Cari Arama Ekranı Default Boş Gelsin"
                  hide-details=""   >
                </v-switch>
              </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

            </v-layout>
          </v-container>

        </v-layout>
      </v-card>
    </v-form>






    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
          :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}

          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>

<script>
  import auth from '../../../api/auth'

  export default {
    data() {
      return {
        date: null,
        dateFormatted: null,
        menu: false,
        drawer: null,
        baslik: '',

        BiletRaporParametre: {
          ParametrePath: {
            AmadeusPath: null,
            GalileoPath: null,
            TKIchatPath: null,
            AtlasPath: null,
            OnurAirPath: null,
            PegasusPath: null,
            YedekPath: null,
            XmlPath: null,
            WordSpanPath: null,
            SabrePath: null,
            PdfPath: null
          },
          ParametreFaturaDizayn: {
            IcHatFaturaMail: null,
            DisHatFaturaMail: null,
            IcHatFaturaPdf: null,
            DisHatFaturaPdf: null,
            IcHatFatura: null,
            IcHatDovizFatura: null,
            DisHatFatura: null,
            DisHatDovizFatura: null,
            CariHaraketFatura: null,
            FaturaBoy: null,
            FaturaEn: null,
            DekontBoy: null,
            DekontEn: null
          },
          ParametreCari: {
            IskontoHesap: null,
            AmadeusHesap: null
          },
          ParametreAktarim: {
            OptatBiletOtomatikAktar: false,
            ElektronikBiletOtomatikAktar: false,
            AtlasCashBiletKrediliAktar: false,
            TKIcHatOtomatikCariAktar: false,
            GalileoDisOtomatikCariAktar: false,
            AmadeusDisOtomatikCariAktar: false,
            AmadeusGalileoCariEslestirmeYok: false,
            AmadeusServisOlmasadaCariAktar: false,
            AtlasPegasusServisBileteEkle: false,
            PegasusSunExpressExBiletAktarma: false,
            SabreKurumsal: false
          },
          ParametreFatura: {
            FaturaAyriSeri: false,
            DekontKrediKartNo: false,
            DekontBiletAciklama: false,
            DekontBaslikYok: false,
            FaturaPdf: false,
            FirmaKartKontrol: false,
            DekontSirket: false
          },
          ParametreFaturaBaglanti: {
            KullaniciAdi: null,
            Sifre: null,
            Url: null
          }
        },


        tumparametreler: [],
        dialog: false,



        text1: '',
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000
      }
    },
    beforeMount: beforeMount,

    methods: {
      processFile(event) {

        var input = document.getElementById("fileUpload");
        var fReader = new FileReader();
        fReader.readAsDataURL(input.files[0]);
        fReader.onloadend = function (event) {
          console.log('iueiu' + event.target.result.value)
        }
        console.log(document.getElementById("fileUpload").files[0].name)
        this.text1 = event.target.value
      },
      formatDate(date) {
        var str = date
        var n = str.search('.')
        if (n == 1) {
          return null
        } else {
          const [year, month, day] = date.split('-')
          return `${day}.${month}.${year}`
        }
      },
      parseDate(date) {
        if (!date) return null
        var str = date
        var n = str.search('-')
        var m = str.length
        if (n == 1) {
          const [month, day, year] = date.split('-')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        } else if (m == 8) {
          console.log('')
        } else if (n == -1 && m != 8) {
          this.dateFormatted = getDateNow()
          this.date = getDateNow()
        } else {
          const [day, month, year] = date.split('.')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        }
      },
      onChange: onChange,
      getDateNow: getDateNow,
      toDateformat: toDateformat,
      Kaydet: Kaydet
    },
  }

  function Kaydet() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      GenelParametre: this.tumparametreler.GenelParametre,
      RaporParametre: this.BiletRaporParametre,
      FirmaParametre: this.tumparametreler.FirmaParametre,
      SirketKodu: credentials.SirketKodu
    }


    this.$http.post(auth.API_URL + 'api/TicketParametre/TicketParametreAdd', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.text1 = response.body.ResponseMessage
      this.snackbar = true

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true

      }
    })
  }



  function beforeMount() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }
    this.$http.post(auth.API_URL + 'api/TicketParametre/TicketParametreGet', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.tumparametreler = response.body
      this.BiletRaporParametre = response.body.RaporParametre


    }, (response) => {
      if (response.status === 0) {
        this.text = 'Service Unavailable'
        this.snackbar = true

      } else {
        this.text = 'Service Unavailable'
        this.snackbar = true

      }
    })
  }

  function toDateformat(dateStr) {
    var parts = dateStr.split("-");
    return (parts[2] + '.' + parts[1] + '.' + parts[0]);
  }

  function onChange(v) {
    var c = v.length
    var a = v
    if (c == 8) {
      var b = a[4] + a[5] + a[6] + a[7] + '-' + a[2] + a[3] + '-' + a[0] + a[1]
      this.date = b
    } else {
      this.dateFormatted = null
    }
  }


  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = dd + '-' + mm + '-' + yyyy
    return today
  }
</script>
<style>

</style>